import { Injectable } from '@angular/core';
import { Device, DeviceState } from '@era/locations-sdk';
import { DeviceStoreActions, RouterStoreStates } from '@era/stores';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';

@Injectable()
export class UnavailableDevicesResolver {
  constructor(
    private readonly deviceStore: Store<Device>,
    private readonly routerStore: Store<RouterStoreStates.RouterState>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.pipe(
      tap(() => {
        this.deviceStore.dispatch(
          DeviceStoreActions.DeviceResolverActions.devicesForStateRequested({ state: DeviceState.Unavailable })
        );
      }),
      map(() => true),
      first()
    );
  }
}
